(() => {
  // DRF 4 category pages: AJAX quick add ([data-drf-cat-add]) that opens the theme's cart drawer.
  // Guarded, because several sections on one page include this script.
  if (window.__drfCategory) return;
  window.__drfCategory = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function add(form) {
    const button = form.querySelector('button[type="submit"]');
    if (button) { button.disabled = true; button.classList.add('is-loading'); }
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) throw new Error('add failed');
      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      const drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (drawer) {
        if (!drawer.classList.contains('drawer--visible')) {
          const toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
          if (toggle) toggle.click();
          else drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
        }
      } else {
        window.location.href = `${root}cart`;
      }
    } catch (e) {
      form.submit();
    } finally {
      if (button) { button.disabled = false; button.classList.remove('is-loading'); }
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('[data-drf-cat-add]');
    if (!form) return;
    event.preventDefault();
    add(form);
  });
})();
